import { useParams } from 'react-router-dom';
import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { fetchPlanById } from 'api/transactionPlans';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { TransactionPlan } from 'types/domain';

interface UseCurrentPlanOrByIdOptions<T extends TransactionPlan>
    extends Omit<UseSuspenseQueryOptions<TransactionPlan, DefaultError, T, any>, 'queryKey'> {
    planId?: number;
}

const useCurrentPlanOrById = <T extends TransactionPlan>(
    options: UseCurrentPlanOrByIdOptions<T> = {},
) => {
    const { planId: id, ...restOptions } = options;
    const { accountId } = useCurrentAccount();
    const params = useParams<{ plan_id: string }>();
    const planId = id ?? parseInt(params.plan_id);

    return useSuspenseQuery({
        queryKey: accountQueryKeys.planById(accountId, planId),
        queryFn: () => fetchPlanById(accountId, planId),
        ...restOptions,
    });
};

export { useCurrentPlanOrById };
